export default function arrayToCsv(values: string[]): string {
    return values.map((f) => JSON.stringify(f)).join(',');
}
